import PropTypes from 'prop-types';
import React from 'react';
import Dialog from './dialog.jsx';
import DestinationSections from './destination_sections.jsx';
import classnames from 'classnames';
import Tooltip from 'react-aria-tooltip';
import { ALLOWED_UPLOAD_TYPES } from '../const';

function ValidationError({ error, id }) {
    if (error) {
        return (
            <div className="validation-error" id={id} role="alert" aria-invalid>
                <span className="aural">Invalid: </span>
                {error}
            </div>
        );
    }
    return <span />;
}
ValidationError.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    id: PropTypes.string,
};

export default class UploadDisplay extends React.Component {
    static displayName = 'UploadDisplay';

    static propTypes = {
        sections: PropTypes.any,
        terms: PropTypes.any,
        selectedSections: PropTypes.array,
        title: PropTypes.string,
        tos: PropTypes.bool,
        description: PropTypes.string,
        setContent: PropTypes.func,
        setTitle: PropTypes.func,
        setTos: PropTypes.func,
        setDescription: PropTypes.func,
        onSave: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        validationErrors: PropTypes.object.isRequired,
        clearContent: PropTypes.func.isRequired,
    };

    componentWillUnmount() {
        this.props.clearContent();
    }

    setDescription = ({ currentTarget: { value } }) => {
        this.props.setContent({ description: value });
    };

    setSelectedSections = selectedSections => {
        this.props.setContent({ selectedSections });
    };

    setTitle = ({ currentTarget: { value } }) => {
        this.props.setContent({ title: value });
    };

    setTos = ({ currentTarget: { checked } }) => {
        this.props.setContent({ tos: checked });
    };

    fileInputRef = el => {
        this.fileInput = el;
    };

    render() {
        const {
            description,
            sections,
            selectedSections,
            terms,
            title,
            tos,
            validationErrors,
        } = this.props;

        const buttons = [];
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Upload Material',
            onClick: () => {
                const element = this.fileInput;
                this.props.onSave(element);
            },
            primary: true,
        });

        return (
            <Dialog
                buttons={buttons}
                closeButton
                onClose={this.props.onClose}
                title="Upload Material"
            >
                <div>
                    <p>All fields are required unless otherwise noted.</p>
                    <fieldset id="select-file" className="well">
                        <legend className="aural">Document Upload</legend>
                        <label
                            className={classnames({
                                'validation-error': validationErrors.file,
                            })}
                            htmlFor="_engage62"
                        >
                            Select a file from your computer. Your file must be
                            less than 15MB in size.
                        </label>
                        <Tooltip
                            message={ALLOWED_UPLOAD_TYPES.join(', ')}
                            eventType="hover"
                            direction="right"
                        >
                            <span>Supported file extentions</span>
                            <i
                                className="cl-icon cl-icon-question-circle"
                                aria-hidden
                            />
                        </Tooltip>
                        <div className="well">
                            <input
                                ref={this.fileInputRef}
                                required
                                type="file"
                                id="_engage62"
                                aria-required
                                aria-describedby="_engage62_error"
                            />
                        </div>
                        <ValidationError
                            error={validationErrors.file}
                            id="_engage62_error"
                        />
                    </fieldset>
                    <fieldset>
                        <legend className="aural">Document Title</legend>
                        <label
                            className={classnames({
                                'validation-error': validationErrors.title,
                            })}
                            htmlFor="_engage63"
                        >
                            Title
                        </label>
                        <input
                            value={title}
                            onChange={this.setTitle}
                            required
                            type="text"
                            id="_engage63"
                            aria-required
                            aria-describedby="_engage63_error"
                        />
                        <ValidationError
                            error={validationErrors.title}
                            id="_engage63_error"
                        />
                    </fieldset>
                    <fieldset>
                        <legend className="aural">Document Description</legend>
                        <label htmlFor="_engage64">
                            Description
                            <span className="secondary">(Optional)</span>
                        </label>
                        <textarea
                            value={description}
                            onChange={this.setDescription}
                            id="_engage64"
                        />
                    </fieldset>

                    <ValidationError
                        error={validationErrors.sections}
                        id="error-sections"
                    />
                    <DestinationSections
                        sections={sections}
                        terms={terms}
                        selectedSections={selectedSections}
                        onChange={this.setSelectedSections}
                        error={validationErrors.sections}
                    />

                    <fieldset className="important">
                        <legend className="aural">
                            Terms of Service Agreement
                        </legend>
                        <input
                            checked={tos}
                            onChange={this.setTos}
                            type="checkbox"
                            id="tos"
                            required
                            aria-describedby="tos_error"
                        />
                        <label
                            className={classnames({
                                'validation-error': validationErrors.title,
                            })}
                            htmlFor="tos"
                        >
                            <p>
                                I certify that I have the right to distribute
                                this information and that it does not violate
                                the Engage or my academic institution Terms of
                                Service.
                            </p>
                        </label>
                        <ValidationError
                            error={validationErrors.tos}
                            id="tos_error"
                        />
                    </fieldset>
                </div>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/upload_material_dialog.ui.jsx